<template>
  <div>
    <Head title="Create Business"/>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='Link' href="/sector-targets">Sector Targets</b-breadcrumb-item>
      <b-breadcrumb-item tag='Link' :href="'/sector-targets/'+business.sector_target.id">{{
          business.sector_target.label
        }}
      </b-breadcrumb-item>
      <b-breadcrumb-item tag='Link' active>
        Create Business
      </b-breadcrumb-item>
    </b-breadcrumb>

    <card-component title="Create Business">
      <form @submit.prevent="update">
        <select-input v-model="form.user_id" :error="form.errors.user_id" expanded class="mb-2" label="Assigned User">
          <option v-for="user in users" :key="user.id" :value="user.id">
            {{ user.first_name }} {{ user.last_name }}
          </option>
        </select-input>

        <text-input v-model="form.name" :error="form.errors.name" class="mb-2" label="Business Name"/>
        <text-input id="autocomplete" ref="address" v-model="form.address" :error="form.errors.address" class="mb-2"
                    label="Address"/>
        <text-input ref="address2" v-model="form.address2" :error="form.errors.address2" class="mb-2"
                    label="Address 2"/>
        <text-input v-model="form.city" :error="form.errors.city" class="mb-2" label="City"/>
        <state-select ref="state" v-model="form.state" :error="form.errors.state" class="mb-2" label="State"/>
        <text-input v-model="form.postal_code" :error="form.errors.postal_code" class="mb-2" label="Postal Code"/>
        <text-input v-model="form.domain" :error="form.errors.domain" class="mb-2" label="URL"/>
        <div class="is-flex is-justify-content-flex-end mt-4">
          <loading-button :loading="form.processing" class="button is-info" type="submit">Save Business
          </loading-button>
        </div>
      </form>
    </card-component>

  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import StateSelect from '@/Shared/StateSelect'
import SelectInput from '@/Shared/SelectInput.vue'
import CardComponent from "@/Shared/CardComponent.vue";

export default {
  components: {
    CardComponent,
    SelectInput,
    StateSelect,
    LoadingButton,
    TextInput,
  },
  remember: 'form',
  props: {
    business: Object,
    users: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        user_id: this.users[0].id,
        name: this.business.name,
        address: this.business.address,
        address2: this.business.address2,
        city: this.business.city,
        state: this.business.state,
        sector_target_id: this.business.sector_target ? this.business.sector_target.id : null,
        postal_code: this.business.postal_code,
        domain: this.business.domain ? this.business.domain.name : null,
      }),
      autocomplete: null,
    }
  },
  mounted() {
    this.autocomplete = new google.maps.places.Autocomplete(this.$refs.address.inputRef, {
      componentRestrictions: {country: ['us', 'ca']},
      fields: ['address_components'],
      types: ['address'],
    })
    this.autocomplete.addListener('place_changed', this.fillAddressFields)

  },
  methods: {
    update() {
      this.form.put('/sector-targets/' + this.business.sector_target.id + '/businesses/' + this.business.id)
    },
    fillAddressFields() {
      let address1 = ''
      let postal_code = ''
      const place = this.autocomplete.getPlace()
      for (const component of place.address_components) {
        const componentType = component.types[0]
        switch (componentType) {
          case 'street_number': {
            address1 = `${component.long_name} ${address1}`
            this.form.address = address1
            break
          }
          case 'route': {
            address1 += component.short_name
            this.form.address = address1
            break
          }
          case 'postal_code': {
            postal_code = `${component.long_name}`
            break
          }
          case 'postal_code_suffix': {
            postal_code = `${postal_code}-${component.long_name}`
            break
          }
          case 'locality': {
            this.form.city = `${component.long_name}`
            break
          }
          case 'administrative_area_level_1': {
            this.form.state = component.short_name
            this.$refs.state.selected = component.short_name;
            break
          }
        }
        this.form.address = address1
        this.form.postal_code = postal_code
        this.$refs.address2.focus()
      }
    },
  },
}
</script>
